import styled from 'styled-components';
export const Over =styled.div `
    width:100%;
    position: relative;
    z-index: 0;
`

export const FontFamily =styled.div `
    font-family: 'Great Vibes', cursive;
    color: #FA9E19;

`
export const HomeSection = styled.div `
    padding: 150px 0em;
    background-color: #2c1342;
`
export const Float = styled.div `
    float: right;
`
export const Flex = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
`
export const Btn =styled.div `
    background-color: #FA9E19;
`
export const Imag =styled.img `
    width: 100%;
` 